import React, { useState, useEffect } from 'react';
import { Layout, Menu, Dropdown, Avatar, message, Button, Drawer } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { UserOutlined, MenuOutlined } from '@ant-design/icons';
import API_BASE_URL from '../config/api';
import axios from 'axios';

const { Header, Content, Sider } = Layout;

const MainLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;

  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [profile, setProfile] = useState(null);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = {
        ...res.data,
        address: {
          province: res.data.province,
          district: res.data.district,
          subdistrict: res.data.subdistrict
        }
      };
      setProfile(data);
    } catch (err) {
      message.error('ไม่สามารถโหลดข้อมูลโปรไฟล์');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    dispatch(logout());
    message.success('ออกจากระบบเรียบร้อยแล้ว');
    navigate('/');
  };

  const handleProfile = () => {
    navigate('/me');
  };

  const menuItems = (
    <>
      <Menu.Item key="/dashboard">ภาพรวม</Menu.Item>
      <Menu.Item key="/maps">แผนที่วัด</Menu.Item>
      <Menu.Item key="/temples">ข้อมูลวัด</Menu.Item>
      <Menu.Item key="/monks">พระภิกษุ/สามเณร</Menu.Item>
      <Menu.Item key="/news-managments">จัดการข่าว</Menu.Item>
      {profile?.level === 'ภาค' && (
        <Menu.Item key="/users">จัดการผู้ใช้</Menu.Item>
      )}
    </>
  );

  const userMenu = (
    <Menu>
      <Menu.Item key="home" onClick={() => navigate('/')}>
        หน้าหลัก
      </Menu.Item>
      <Menu.Item key="me" onClick={handleProfile}>
        โปรไฟล์
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        ออกจากระบบ
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: '100vh', marginLeft: collapsed ? 0 : 0  }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => setDrawerVisible(broken)}
        style={{
          background: '#ad7c00',
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1000,
        }}
        width={200}
      >
        <div style={{ color: '#fff', padding: 16, textAlign: 'center', fontSize: 24,  marginLeft: collapsed ? 0 : 0  }}>
          🛕 สารสนเทศคณะสงฆ์
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[currentPath]}
          onClick={({ key }) => navigate(key)}
          style={{ background: '#ad7c00' }}
        >
          {menuItems}
        </Menu>
      </Sider>

      {/* Mobile Drawer Menu */}
      <Drawer
        placement="left"
        closable={false}
        onClose={() => setDrawerVisible(false)}
        visible={drawerVisible}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={[currentPath]}
          onClick={({ key }) => {
            navigate(key);
            setDrawerVisible(false);
          }}
        >
          {menuItems}
        </Menu>
      </Drawer>

      <Layout style={{ marginLeft: collapsed ? 0 : 0 }}>
        <Header
          style={{
            background: '#fff',
            padding: '0 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
              style={{ marginRight: 16, display: 'inline-block' }}
              className="mobile-toggle"
            /> */}
            <div style={{ color: '#000', fontWeight: 'bold', fontSize: 20, marginLeft: collapsed ? 0 : 260  }}>
              ระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธรรมยุต)
            </div>
          </div>

          <Dropdown overlay={userMenu} placement="bottomRight" arrow>
            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
              <span>{user?.name || 'ผู้ใช้งาน'}</span>
            </div>
          </Dropdown>
        </Header>

        <Content style={{ margin: 16, marginLeft: collapsed ? 0 : 260 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
